import { Modal } from '../components/ui/Modal.jsx';
import { PERUT_EMAIL, PERUT_NASLOV, PERUT_TELEFON, ZDRAVNISKI_VELJAVNOST_MESECEV } from '../config.js';

/*
  Politika zasebnosti.

  Aplikacija hrani fotografije osebnih izkaznic, zdravniška potrdila,
  datume rojstva in naslove. To so osebni podatki in del jih je posebne
  vrste (zdravje), zato mora biti jasno zapisano, kaj se hrani, zakaj,
  kako dolgo in kaj lahko posameznik zahteva.

  ⚠️ Besedilo je pripravljeno na podlagi tega, kar aplikacija dejansko
  počne. Ni pravni nasvet — roke hrambe in pravno podlago naj potrdi
  nekdo, ki pozna področno zakonodajo. Mesta, ki jih mora Luka preveriti,
  so označena spodaj v HANDOFF.md.
*/

const PODATKI = [
  {
    kaj: 'Ime, priimek, datum in kraj rojstva, naslov, pošta',
    zakaj: 'Identifikacija tečajnika in prijava na izpit pri agenciji.',
  },
  {
    kaj: 'Elektronski naslov in telefonska številka',
    zakaj: 'Obveščanje o šolanju in stik ob spremembah.',
  },
  {
    kaj: 'Kontaktna oseba v nujnih primerih',
    zakaj: 'Klic ob nesreči na terenu.',
  },
  {
    kaj: 'Višina in teža',
    zakaj: 'Izbira ustrezne velikosti krila in nastavitev opreme.',
  },
  {
    kaj: 'Zdravstvene omejitve in zdravniško spričevalo za B kategorijo',
    zakaj:
      'Zakonski pogoj za šolanje in izpit. To so podatki o zdravju — hranimo jih ločeno, v zasebnem prostoru, dostopna sta samo tebi in inštruktorju.',
    obcutljivo: true,
  },
  {
    kaj: 'Fotografija osebne izkaznice (sprednja in zadnja stran)',
    zakaj: 'Preverjanje istovetnosti pri prijavi na izpit.',
    obcutljivo: true,
  },
  {
    kaj: 'Napredek po vajah, knjižica letenja, dnevnik prisotnosti',
    zakaj: 'Evidenca šolanja, ki je pogoj za pristop k izpitu.',
  },
  {
    kaj: 'Odgovor na vprašanje, kje si izvedel za šolo',
    zakaj: 'Da vemo, kje nas ljudje najdejo. Vprašanje je neobvezno.',
  },
  {
    kaj: 'Rezultati zaključnega testa z odgovori in podpisom',
    zakaj: 'Šola mora dokazilo o preverjanju znanja hraniti po predpisih.',
  },
];

export function Zasebnost({ onClose }) {
  return (
    <Modal eyebrow="Varstvo osebnih podatkov" title="Kako ravnamo s tvojimi podatki" onClose={onClose}>
      <div className="stack stack--loose">
        <section className="stack stack--tight">
          <h3>Kdo podatke obdeluje</h3>
          <p className="t-md">
            Perut Paragliding, {PERUT_NASLOV}. Kontakt: <a href={`mailto:${PERUT_EMAIL}`}>{PERUT_EMAIL}</a>,{' '}
            {PERUT_TELEFON}.
          </p>
        </section>

        <section className="stack stack--tight">
          <h3>Kaj hranimo in zakaj</h3>
          <ul className="stack stack--tight" style={{ listStyle: 'none' }}>
            {PODATKI.map((p) => (
              <li
                key={p.kaj}
                className="card card--pad"
                style={
                  p.obcutljivo
                    ? { borderColor: 'var(--wait-border)', background: 'var(--wait-wash)' }
                    : undefined
                }
              >
                <div className="t-md t-bold">{p.kaj}</div>
                <div className="t-sm t-dim" style={{ marginTop: 2 }}>
                  {p.zakaj}
                </div>
              </li>
            ))}
          </ul>
        </section>

        <section className="stack stack--tight">
          <h3>Komu so dostopni</h3>
          <p className="t-md">
            Samo tebi in inštruktorju. Drugi tečajniki tvojih podatkov ne vidijo.
            Podatkov ne prodajamo in jih ne pošiljamo tretjim za oglaševanje.
          </p>
          <p className="t-md">
            Ob prijavi na izpit prijavnico in kopijo zdravniškega pošlješ{' '}
            <strong>sam</strong> Javni agenciji za civilno letalstvo — tega ne
            naredimo namesto tebe.
          </p>
          <p className="t-sm t-dim">
            Podatki so shranjeni pri ponudniku Supabase (strežniki v EU). Prijava poteka
            prek Googla — Google ob prijavi izve, da uporabljaš to aplikacijo.
          </p>
        </section>

        <section className="stack stack--tight">
          <h3>Kako dolgo</h3>
          <ul className="stack stack--tight t-md" style={{ paddingLeft: '1.1rem' }}>
            <li>
              <strong>Fotografije dokumentov</strong> — do konca šolanja. Izbrišeš jih
              lahko kadarkoli sam, v razdelku Dokumenti.
            </li>
            <li>
              <strong>Zdravniško spričevalo</strong> velja {ZDRAVNISKI_VELJAVNOST_MESECEV}{' '}
              mesecev; po tem ga ne potrebujemo več.
            </li>
            <li>
              <strong>Evidenca šolanja in zaključni test</strong> — hranimo ju toliko časa,
              kot predpisuje zakonodaja o šolanju pilotov. Tega dela ne moremo izbrisati na
              zahtevo.
            </li>
          </ul>
        </section>

        <section className="stack stack--tight">
          <h3>Kaj lahko zahtevaš</h3>
          <p className="t-md">
            Dostop do svojih podatkov, popravek, izvoz in izbris. Popravke narediš sam v
            svojem profilu, izvoz in zahtevo za izbris pa najdeš prav tam.
          </p>
          <p className="t-sm t-dim">
            Če misliš, da s tvojimi podatki ravnamo narobe, se lahko pritožiš
            Informacijskemu pooblaščencu RS.
          </p>
        </section>
      </div>
    </Modal>
  );
}
